'use client';

import { useGlobalClientContext } from '../../../modules/common/GlobalClientContext';
import React from 'react';
import { convertBoldTagsToStrong } from '@altus-ui/components_v2/utils/text';
import { I18nResKeys } from '@altus-ui/i18n/messages/i18n-types';

export default function ConsentPersonalInformationMarketV1() {
  const {
    i18nHelper: { t }
  } = useGlobalClientContext();
  const getText = (key: string) => t(key as I18nResKeys, {});
  const formatBold = (key: string) => convertBoldTagsToStrong(getText(key));

  return (
    <div className="flex flex-col text-sm text-primary leading-md not-italic">
      <div className="flex flex-col">
        <p className="font-semibold whitespace-pre-wrap">
          {getText('consent.to.marketing_1st.section_title')}
        </p>
        <ul className="flex flex-col">
          <li className="flex items-start font-regular whitespace-pre-wrap">
            <span>•</span>
            <span>
              {formatBold('consent.to.marketing_1st.section_1st.bullet')}
            </span>
          </li>
          <li className="flex items-start font-regular whitespace-pre-wrap">
            <span>•</span>
            <span>
              {formatBold('consent.to.marketing_1st.section_2nd.bullet')}
            </span>
          </li>
        </ul>
      </div>

      <br />

      <div className="flex flex-col">
        <p className="font-semibold whitespace-pre-wrap">
          {getText('consent.to.marketing_2nd.section_title')}
        </p>
        <p className="font-regular whitespace-pre-wrap">
          {formatBold('consent.to.marketing_2nd.section_content')}
        </p>
      </div>

      <br />

      <div className="flex flex-col">
        <p className="font-semibold whitespace-pre-wrap">
          {getText('consent.to.marketing_3rd.section_title')}
        </p>
        <p className="font-semibold whitespace-pre-wrap">
          {formatBold('consent.to.marketing_3rd.section_content')}
        </p>
      </div>

      <br />

      <div className="flex flex-col">
        <p className="font-semibold whitespace-pre-wrap">
          {getText('consent.to.marketing_4th.section_title')}
        </p>
        <p className="font-regular whitespace-pre-wrap">
          {formatBold('consent.to.marketing_4th.section_content')}
        </p>
      </div>
    </div>
  );
}
